import {Injectable, Renderer2, RendererFactory2} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FullScreenService {
  private renderer: Renderer2;

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  toggleFullScreen(): void {
    if (!document.fullscreenElement) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if ((document as any).msRequestFullscreen) { // For IE/Edge
        (document as any).msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if ((document as any).msExitFullscreen) { // For IE/Edge
        (document as any).msExitFullscreen();
      }
    }
  }

  initFullScreen(): void {
    this.renderer.listen('document', 'fullscreenchange', this.exitHandler.bind(this));
    this.renderer.listen('document', 'MSFullscreenChange', this.exitHandler.bind(this)); // For IE/Edge
  }

  private exitHandler(): void {
    if (!document.fullscreenElement) {
      this.renderer.removeClass(document.body, 'fullscreen-enable');
    }
  }
}
